module.exports = __webpack_public_path__ + "media/application/images/projects/images/australia-83e1c3a21ed8e40d81279f3a8816f68e.jpg";